// extracted by mini-css-extract-plugin
export default {"test":"ChooseUniformItem_test__jpX9P","chooseUniformStyleText":"ChooseUniformItem_chooseUniformStyleText__fWVMg"};